__turbopack_context__.v({
  "icon": "M8BPBG_icon",
  "loader-animation": "M8BPBG_loader-animation",
  "root": "M8BPBG_root",
});
